import React from 'react';
import { View, Image, ScrollView } from 'react-native';
import useTranslation from '../../hooks/translation-hook';
import CustomButton from '../common/CustomButton';
import CustomMarkdown from '../common/CustomMarkDown';
import Label from '../common/Label';

export interface LocationPermissionProps {
  onClose?(): void;
}

const NotificationPermission = (props: LocationPermissionProps) => {
  const t = useTranslation();

  return (
    <ScrollView style={{ flexGrow: 0, backgroundColor: '#eeeef0', maxWidth: 350 }}>
      <Image source={require('../../../assets/onBoarding_mobile_3.png')} style={{ aspectRatio: '350/234', width: '100%', height: 'auto' }} />
      <View style={{ flexGrow: 1, marginTop: 8 }}>
        <View style={{ margin: 'auto', paddingLeft: 12, paddingRight: 12, paddingBottom: 24 }}>
          <Label style={{ fontSize: 28, color: '#f5a523', fontWeight: '600' }} numberOfLines={3}>
            {t('Notifications')}
          </Label>
          <Label style={{ marginTop: 20, fontSize: 18, color: '#33264d', fontWeight: '400' }} numberOfLines={10}>
            {t('Well-use-notifications-to-keep-you-updated-on-miss')}
          </Label>
          <Label style={{ marginTop: 16, fontSize: 18, color: '#33264d', fontWeight: '400' }} numberOfLines={10}>
            {t('Stay-informed-and-never-miss-an-opportunity')}
          </Label>
          <CustomButton
            style={{ marginTop: 24 }}
            title={t('Okay')}
            onPress={() => {
              props.onClose && props.onClose();
            }}
          />
        </View>
      </View>
    </ScrollView>
  );
};

export default NotificationPermission;
